<ng-template #popupTpl>
  <div [class]="popupClass()">

    <div class="flex items-start gap-3 mb-2">
      @if (tourService.currentStep()?.title) {
        <h3 class="flex-1 m-0 text-[15px] font-semibold leading-snug text-gray-900 dark:text-gray-50">
          {{ tourService.currentStep()!.title }}
        </h3>
      }
      <span class="ml-auto pt-0.5 shrink-0 whitespace-nowrap text-xs text-gray-400">
        {{ tourService.currentVisibleStepNumber() }} of {{ tourService.visibleStepCount() }}
      </span>
    </div>

    <p class="m-0 mb-5 text-sm leading-relaxed text-gray-600 dark:text-gray-300">
      {{ tourService.currentStep()?.text }}
    </p>

    @if (tourService.currentStep() && tourService.currentStep()?.buttons !== null) {
      <div class="flex flex-wrap items-center justify-between gap-2" [class.justify-end!]="tourService.isLastVisibleStep()">
        @if (!tourService.isLastVisibleStep()) {
          <app-link (click)="tourService.stop()">
            <span class="text-xs">Skip</span>
          </app-link>
        }

        @if (tourService.currentStep()?.buttons?.length) {
          @for (btn of tourService.currentStep()!.buttons!; track btn.text) {
            <app-button (click)="btn.action()" [variant]="btn?.variant ?? 'primary'" size="x-small">
              @if (btn.icon) {
                <app-icons [icon]="btn.icon" svgClass=""/>
              } @else {
                {{ btn.text }}
              }
            </app-button>
          }
        } @else {
          <div class="flex items-center gap-2">
            @if (!tourService.isFirstVisibleStep()) {
              <app-button size="x-small" variant="secondary" (click)="handlePrev()">
                <app-icons icon="arrow-left" svgClass=""/>
              </app-button>
            }

            <app-button size="x-small" (click)="handleNext()">
              @if (tourService.isLastVisibleStep()) {
                <app-icons icon="check" svgClass=""/>
              } @else if (tourService.nextStep()?.title; as nextTitle) {
                <div class="max-w-32 truncate text-xs">Next: {{ nextTitle }}</div>
              } @else {
                <app-icons icon="arrow-right" svgClass=""/>
              }
            </app-button>
          </div>
        }
      </div>
    }

  </div>
</ng-template>
